<script>
import applySpendMoney from './applySpendMoney'
export default {
  mounted() {
    this.$on('open', () => this.$refs.dialogBar.$emit('open'));
    this.$on('edit', (task_id, data) => this.$refs.dialogBar.$emit('edit', task_id, data));
    this.$refs.dialogBar.$on('refresh', () => {
      this.$emit('refresh')
    })
  },
  render(h) {
    return (
      <div>
        <applySpendMoney ref="dialogBar" title="用款申请（费用）" basicType="5" props={this.$props}></applySpendMoney>
      </div>
    )
  },
}
</script>
